import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { slackLinkQueryKeys } from "./slackQueryKeys";

/**
 * The Slack account a pending link would bind, for the confirmation page.
 *
 * Not retried: the only failure this route has is "invalid or expired", which retrying cannot
 * change, and each attempt delays telling the person to ask for a fresh link.
 */
export function useSlackLinkNonce(nonce: string) {
  const { slackService } = useDomainServices();

  return useQuery({
    queryKey: slackLinkQueryKeys.nonce(nonce),
    queryFn: ({ signal }) =>
      slackService.getLinkNonce(nonce, { abortSignal: signal }),
    retry: false,
    // A link is short-lived and spent once; refetching it on a window focus can only turn a
    // rendered page into a 404 after the person has already read it.
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
